/**
 * Placeholder route configuration — one entry per "coming soon" feature.
 *
 * The router uses this map to render PlaceholderPage with the right props
 * for each route. Centralized here so adding a new placeholder is a single
 * edit, and migrating to a real page is "remove from this map + add real
 * route in router.tsx".
 */
import {
  Megaphone,
  Phone,
  CreditCard,
  Plug,
    type LucideIcon,
} from "lucide-react";

export type PlaceholderConfig = {
  path: string;
  icon: LucideIcon;
  titleKey: string;
  phase: string;
  descriptionKey: string;
  featureKeys: string[];
};

export const PLACEHOLDERS: PlaceholderConfig[] = [
  // Stub for /messages link from ComposePage success banner.
  // Will be replaced by real Messages history page in UI.2 / UI.1.B.
  
  
  // "senders" graduated to ChannelsSendersPage (WhatsApp tabs) — router.tsx.

  // -------------------------------------------------
  // No-header group
  // -------------------------------------------------
  

  // -------------------------------------------------
  // TOOLS
  // -------------------------------------------------
  // "mnp" graduated to the real MnpPage (MNP-1) -- router.tsx.
  // "otp" graduated to the real OtpPage (OTP-1) -- router.tsx.
  // "qr" graduated to the real QrPage (1st.is tie-in) -- router.tsx.
  // "short-url" graduated to the real ShortUrlPage (1st.is P3) -- router.tsx.
  // "mail2sms" graduated to the real Mail2smsPage (M1, docs/mail2sms-design.md) -- router.tsx.

  // -------------------------------------------------
  // SERVICES
  // -------------------------------------------------
  {
    path: "mobile-advertising",
    icon: Megaphone,
    titleKey: "nav.mobile_advertising",
    phase: "Phase 4.6",
    descriptionKey: "placeholder.mobile_advertising.description",
    featureKeys: [
      "placeholder.mobile_advertising.f1",
      "placeholder.mobile_advertising.f2",
      "placeholder.mobile_advertising.f3",
    ],
  },
  {
    path: "robcall",
    icon: Phone,
    titleKey: "nav.robcall",
    phase: "Phase 4.6",
    descriptionKey: "placeholder.robcall.description",
    featureKeys: [
      "placeholder.robcall.f1",
      "placeholder.robcall.f2",
      "placeholder.robcall.f3",
    ],
  },
  {
    path: "esim",
    icon: CreditCard,
    titleKey: "nav.esim_store",
    phase: "Phase 4.6",
    descriptionKey: "placeholder.esim.description",
    featureKeys: [
      "placeholder.esim.f1",
      "placeholder.esim.f2",
      "placeholder.esim.f3",
    ],
  },

  // -------------------------------------------------
  // BILLING
  // -------------------------------------------------
  // "wallet" graduated to the real WalletPage (WA.P2.c) — see router.tsx.

  // -------------------------------------------------
  // DEVELOPER
  // -------------------------------------------------
  // "api-keys" graduated to the real ApiKeysPage (API-1 step 4) -- router.tsx.
  // "api-playground" graduated to the real PlaygroundPage (API-1 step 7) -- router.tsx.
  {
    path: "integrations",
    icon: Plug,
    titleKey: "nav.integrations",
    phase: "Phase 4.8",
    descriptionKey: "placeholder.integrations.description",
    featureKeys: [
      "placeholder.integrations.f1",
      "placeholder.integrations.f2",
      "placeholder.integrations.f3",
    ],
  },


];
